import React from 'react';
import {Button} from 'primereact/button';
import {Message} from 'primereact/message';
import {Tag} from 'primereact/tag';


const NoInternet = () => {

    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <div className="flex align-items-center justify-content-center min-h-screen bg-blue-50">
            <div className="flex flex-column align-items-center text-center p-4">
                {/* Animated Icon */}
                <div className="text-8xl mb-4 text-blue-500">
                    <i className="pi pi-wifi" style={{ fontSize: '5rem' }}></i>
                </div>

                {/* Main Title */}
                <h1 className="text-4xl font-bold text-900 mb-2">
                    No Internet Connection
                </h1>

                {/* Description */}
                <p className="text-lg text-600 line-height-3 mb-4">
                    It seems you're offline. Please check your internet connection and try again.
                </p>

                {/* Network Status Tags */}
                <div className="flex flex-wrap gap-2 justify-content-center mb-4">
                    <Tag severity="danger" value="Offline" icon="pi pi-times-circle" />
                    <Tag severity="warning" value="Check Connection" icon="pi pi-exclamation-triangle" />
                    <Tag severity="info" value="Retry" icon="pi pi-refresh" />
                </div>

                {/* Troubleshooting Steps */}
                <div className="text-left bg-blue-50 p-4 border-round-lg w-full mb-4">
                    <h3 className="text-lg font-semibold text-800 mb-3 flex align-items-center">
                        <i className="pi pi-question-circle text-blue-500 mr-2"></i>
                        Troubleshooting Steps:
                    </h3>
                    <ul className="p-0 m-0 list-none">
                        <li className="mb-3 flex align-items-center">
                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                            <span className="text-600">Check your Wi-Fi or mobile data</span>
                        </li>
                        <li className="mb-3 flex align-items-center">
                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                            <span className="text-600">Toggle Airplane mode on/off</span>
                        </li>
                        <li className="mb-3 flex align-items-center">
                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                            <span className="text-600">Restart your router</span>
                        </li>
                        <li className="flex align-items-center">
                            <i className="pi pi-check-circle text-green-500 mr-2"></i>
                            <span className="text-600">Check network cables (for wired connections)</span>
                        </li>
                    </ul>
                </div>


                {/* Action Buttons */}
                <div className="flex flex-wrap gap-3 justify-content-center">
                    <Button
                        label="Try Again"
                        icon="pi pi-refresh"
                        className="p-button-rounded p-button-lg"
                        onClick={handleRetry}
                        autoFocus
                    />
                    <Button
                        label="Check Settings"
                        icon="pi pi-cog"
                        className="p-button-rounded p-button-outlined p-button-lg"
                        onClick={() => window.open('network-settings://', '_blank')}
                    />
                </div>

                {/* Additional Help Link */}
                <div className="mt-4">
                    <Message
                        severity="info"
                        text="Need more help? Contact support"
                        className="border-round"
                    />
                </div>

                {/* Network Details */}
                <div className="mt-4 text-sm text-500">
                    <div className="flex align-items-center justify-content-center gap-3">
              <span className="flex align-items-center">
                <i className="pi pi-clock mr-1"></i>
                Last connected: 2 minutes ago
              </span>
                        <span className="flex align-items-center">
                <i className="pi pi-signal mr-1"></i>
                Network: Disconnected
              </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoInternet;